import type { MembershipApiClient } from '@b2ag/module-universcoop-sdk'
import type { AlgoliaSearchService, RecommendService } from '@b2ag/search'
import type { IStockService } from '@b2ag/stock'
import type { IStoreService } from '@b2ag/coop-store'
import type { IDiscountService } from '@b2ag/discount'
import type { IOfferService } from '@b2ag/offers/src/services/offer.service'
import type { IRecommendationService } from '@b2ag/product/src/services/recommendation.service'
import type ProductService from '@b2ag/product/src/services/product.service'
import type CartService from '@b2ag/cart/src/cart.service'
import type LineItemService from '@b2ag/cart/src/line-item.service'
import type { MembershipService } from '@b2ag/membership/src/services/membership.service'
import type { ShoppingListApiClient } from '@b2ag/legacy-shared-shopping-list-sdk'
import type ProfileService from '@b2ag/profile/src/profile.service'
import type UserService from '@b2ag/user/src/user.service'

export * from './interfaces/store.interface'

/* -------- SERVICES for STORE ---------- */

interface ServicesForStore {
  membershipApiClient?: MembershipApiClient
  searchService?: AlgoliaSearchService
  recommendService?: RecommendService
  stockService?: IStockService
  recommendationService?: IRecommendationService
  storeService?: IStoreService
  offerService?: IOfferService
  discountService?: IDiscountService
  productService?: ProductService
  cartService?: CartService
  lineItemService?: LineItemService
  profileService?: ProfileService
  userService?: UserService
  membershipService?: MembershipService
  shoppingListApiClient?: ShoppingListApiClient
}

let singl_servicesForStore = undefined as ServicesForStore | undefined

export function initServicesForStore(servicesForStore: ServicesForStore) {
  singl_servicesForStore = servicesForStore
}

export function getServicesForStore(): ServicesForStore {
  if (!singl_servicesForStore) throw new Error('Services for store were not initialized')
  return singl_servicesForStore
}

/* ---------- DEFAULT ---------- */

export default {}
